import { axiosInstance } from 'src/util/axios.js'
import { useAuthDispatch } from 'src/contexts/authContext'

export interface ILoginCredentials {
  email: string
  password: string
  remember: boolean
}

export interface IGoogleLoginCredentials {
  code: string
}

const useLoginApi = () => {
  const dispatch = useAuthDispatch()

  const login = async ({ email, password, remember }: ILoginCredentials) => {
    const response = await axiosInstance.post('/core/public/login', {
      email,
      password,
    })

    dispatch({
      type: 'LOGIN',
      payload: {
        email: response?.data?.data?.email,
        firstName: response?.data?.data?.firstName,
        lastName: response?.data?.data?.lastName,
        accessToken: response?.data?.token,
        refreshToken: response?.data?.refresh,
        rememberMe: remember,
      },
    })
  }

  const googleLogin = async ({ code }: IGoogleLoginCredentials) => {
    const response = await axiosInstance.post('/core/public/loginWithGoogle', {
      code,
    })

    dispatch({
      type: 'LOGIN',
      payload: {
        email: response?.data?.data?.email,
        firstName: response?.data?.data?.firstName,
        lastName: response?.data?.data?.lastName,
        accessToken: response?.data?.token,
        refreshToken: response?.data?.refresh,
        rememberMe: true,
      },
    })
  }

  return { login, googleLogin }
}

export default useLoginApi
